const getters = {
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  permissions: state => state.user.permissions,
  changePwd: state => state.user.changePwd,
  version: state => state.global.version
}
export default getters
